import { Box, Stack } from '@mui/material';

import { selectExternalInfos } from '@/domain/external/external.selectors';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { FinishMessage } from './FinishMessage';
import { Layout } from './Layout';

export function Step3DonePublic({
  onClickAnswerAgain,
}: {
  onClickAnswerAgain: () => void;
}) {
  const infos = useAppSelector(selectExternalInfos);
  return (
    <Layout userName={infos.userName}>
      <Stack>
        <FinishMessage />
        <Box alignSelf={'center'} mt={4}>
          <FSPrimaryButton onClick={onClickAnswerAgain}>
            {translate('External.answer-again')}
          </FSPrimaryButton>
        </Box>
      </Stack>
    </Layout>
  );
}
